import CData from './CData'

class ConnectedDotCollection {
  constructor(id, connectedDots) {
    this.id = id
    this.connectedDots = connectedDots
  }

  cDataWith(id) {
    const index = this.connectedDots.findIndex(connectedDot => connectedDot.id === id)
    return this.cDataAt(index)
  }

  cDataAt(index) {
    const prevIndex = index - 1
    const nextIndex = index + 1
    const cData = new CData(this.connectedDots[prevIndex], this.connectedDots[index], this.connectedDots[nextIndex])
    return cData
  }
}

export default ConnectedDotCollection


// WEBPACK FOOTER //
// ./src/App/ConnectedDotCollection.js